import React from 'react';
import { observer } from 'mobx-react-lite';

import { Box, Flex, Select } from '@radix-ui/themes';
import { FormField } from 'shared/components';
import { AutocompleteV2 } from 'shared/components/autocomplete-v2';
import { useDebouncedCallback } from 'use-debounce';

import { JobLocationViewModel } from './location.view-model';

const formatCityOptionLabel = (city: { name: string; region?: string }) => {
   return `${city.name}${city.region ? `, ${city.region}` : ''}`;
};

const JobLocationView = ({ viewModel }: { viewModel: JobLocationViewModel }) => {
   const debouncedCities = useDebouncedCallback((query: string) => {
      viewModel.searchCities(query);
   }, 500);

   return (
      <Flex className="job-location" gap="3">
         <FormField
            label="Країна"
            required
            error={viewModel.jobManager.form.controls['country'].error}
         >
            <Select.Root
               size="3"
               value={viewModel.jobManager.form.controls['country'].value}
               onValueChange={viewModel.onCountrySelect}
            >
               <Select.Trigger></Select.Trigger>
               <Select.Content position="popper">
                  <Box maxHeight="250px" mb="3">
                     {viewModel.countries.map((country) => (
                        <Select.Item key={country.id} value={country.id.toString()}>
                           {country.name}
                        </Select.Item>
                     ))}
                  </Box>
               </Select.Content>
            </Select.Root>
         </FormField>

         <FormField label="Місто" required error={viewModel.jobManager.form.controls['city'].error}>
            <AutocompleteV2.Root
               selectedKey={viewModel.jobManager.form.controls['city'].value || null}
               items={viewModel.cityOptions}
               loading={viewModel.citiesLoading}
               placeholder="Виберіть місто"
               disabled={!viewModel.jobManager.form.controls['country'].value}
               getOptionValue={(city) => city.id.toString()}
               getOptionLabel={formatCityOptionLabel}
               onSelect={(city) => {
                  viewModel.onCitySelect(city);
               }}
               onSearch={(value) => {
                  viewModel.clearCitySelection();
                  debouncedCities(value);
               }}
            />
         </FormField>
      </Flex>
   );
};

export const JobLocation = observer(JobLocationView);
